<template>
  <div class="panel-body"
       id="svg-body"></div>
</template>

<script>
import * as d3 from "d3";

export default {
  data: () => {
    return {
      graph: null,
      force: null
    };
  },
  props: { item: Array },
  watch: {
    item: function (val) {
      if (val && val.length > 0) {
        this.graph = this.triplesToGraph(val);
        this.update();
      }
    }
  },
  mounted: function () {
    d3.select("#svg-body")
      .append("svg")
      .attr("id", "svg-content")
      .attr("width", "100%")
      .attr("height", 600);
    this.force = d3.layout.force().size([800, 600]);

    if (this.item && this.item.length > 0) {
      this.graph = this.triplesToGraph(this.item);
      this.update();
    }
  },
  methods: {
    filterNodesById: function (nodes, id) {
      return nodes.filter(function (n) {
        return n.id === id;
      });
    },

    triplesToGraph: function (triples) {
      d3.select("#svg-content").html("");
      //Graph
      var graph = { nodes: [], links: [] };

      //Initial Graph from triples
      triples.forEach(triple => {
        var subjId = triple.subject.value;
        var predId = triple.predicate.value;
        var objId = triple.object.value;

        var subjNode = this.filterNodesById(graph.nodes, subjId)[0];
        var objNode = this.filterNodesById(graph.nodes, objId)[0];

        if (subjNode == null) {
          subjNode = { id: subjId, label: subjId, weight: 1 };
          graph.nodes.push(subjNode);
        }

        if (objNode == null) {
          objNode = { id: objId, label: objId, weight: 1 };
          graph.nodes.push(objNode);
        }

        graph.links.push({
          source: subjNode,
          target: objNode,
          predicate: predId,
          weight: 1
        });
      });

      return graph;
    },

    update: function () {
      // ==================== Add Marker ====================
      d3.select("#svg-content")
        .append("svg:defs")
        .selectAll("marker")
        .data(["end"])
        .enter()
        .append("svg:marker")
        .attr("id", String)
        .attr("viewBox", "0 -5 10 10")
        .attr("refX", 30)
        .attr("refY", -0.5)
        .attr("markerWidth", 6)
        .attr("markerHeight", 6)
        .attr("orient", "auto")
        .append("svg:polyline")
        .attr("points", "0,-5 10,0 0,5");

      // ==================== Add Links ====================
      var links = d3
        .select("#svg-content")
        .selectAll(".link")
        .data(this.graph.links)
        .enter()
        .append("line")
        .attr("marker-end", "url(#end)")
        .attr("class", "link")
        .attr("stroke-width", 1); //links
      // ==================== Add Link Names =====================
      var linkTexts = d3
        .select("#svg-content")
        .selectAll(".link-text")
        .data(this.graph.links)
        .enter()
        .append("text")
        .attr("class", "link-text")
        .html(function (d) {
          let link = d.predicate;
          if (d.predicate.startsWith("http")) {
            let dom = document.createElement("a");
            dom.setAttribute("href", d.predicate);
            dom.setAttribute("target", "_blank");
            dom.appendChild(document.createTextNode(d.predicate));
            link = dom.outerHTML;
          }
          return link;
        });
      //linkTexts.append("title")
      //		.text(function(d) { return d.predicate; });

      // ==================== Add Link Names =====================
      var nodeTexts = d3
        .select("#svg-content")
        .selectAll(".node-text")
        .data(this.graph.nodes)
        .enter()
        .append("text")
        .attr("class", "node-text")
        .html(function (d) {
          let link = d.label;
          if (d.label.startsWith("http")) {
            let dom = document.createElement("a");
            dom.setAttribute("href", d.label);
            dom.setAttribute("target", "_blank");
            dom.appendChild(document.createTextNode(d.label));
            link = dom.outerHTML;
          }
          return link;
        });
      //nodeTexts.append("title")
      //		.text(function(d) { return d.label; });

      // ==================== Add Node =====================
      var nodes = d3
        .select("#svg-content")
        .selectAll(".node")
        .data(this.graph.nodes)
        .enter()
        .append("circle")
        .attr("class", "node")
        .attr("r", 8)
        .call(this.force.drag); //nodes
      // ==================== Force ====================
      this.force.on("tick", function () {
        nodes
          .attr("cx", function (d) {
            return d.x;
          })
          .attr("cy", function (d) {
            return d.y;
          });

        links
          .attr("x1", function (d) {
            return d.source.x;
          })
          .attr("y1", function (d) {
            return d.source.y;
          })
          .attr("x2", function (d) {
            return d.target.x;
          })
          .attr("y2", function (d) {
            return d.target.y;
          });

        nodeTexts
          .attr("x", function (d) {
            return d.x + 12;
          })
          .attr("y", function (d) {
            return d.y + 3;
          });

        linkTexts
          .attr("x", function (d) {
            return 4 + (d.source.x + d.target.x) / 2;
          })
          .attr("y", function (d) {
            return 4 + (d.source.y + d.target.y) / 2;
          });
      });

      // ==================== Run ====================
      this.force
        .nodes(this.graph.nodes)
        .links(this.graph.links)
        .charge(-500)
        .linkDistance(250)
        .start();
    }
  }
};
</script>

<style lang="scss">
.node {
  stroke: #fff;
  fill: #ddd;
  stroke-width: 1.5px;
}

.link {
  stroke: #999;
  stroke-opacity: 0.6;
  stroke-width: 1px;
}

marker {
  stroke: #999;
  fill: rgba(124, 240, 10, 0);
}

.node-text {
  font: 11px sans-serif;
  fill: black;
}

.link-text {
  font: 9px sans-serif;
  fill: grey;
}

#svg-body {
  svg {
    border: 1px solid black;
  }
}
</style>
